import { Component, OnInit, Input, ViewEncapsulation, AfterContentInit } from '@angular/core';
import { ControlValueAccessor, FormGroup, FormBuilder } from '@angular/forms';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';

import { Field, FileField, MultiSelectField, MultiSelectListField } from '../../../models';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { FieldService } from '../../../services/field.service';
import { ConditionService } from '../../../services/condition.service';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';
import { UscUserLookupComponent } from '../usc-user-lookup/usc-user-lookup.component';
import { BehaviorSubject } from 'rxjs';
import { DialogService } from '../../../services';

@Component({
    selector: 'sn-usc-modal',
    templateUrl: './usc-modal.component.html',
    styleUrls: ['../usc-store.component.css', './usc-modal.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class UscModalComponent {
    @Input() openCustomInputEvent: Function;
    @Input() onCustomValidateEvent: Function;
    @Input() onObservableValidateEvent: Observable<any>;
    @Input() onSubmitOverrideEvent: Function;
    @Input() view: string;
    @Input() data: any;    // this is the view item from the list view which may not contain all properties needed for this modal

    formFields: Array<Field<any>> = [];
    valueChangeFields: Array<Field<any>> = [];
    showOptions: boolean = false;
    form: FormGroup;
    viewSettings: any;
    viewFields: any;
    viewConditions: any;
    viewFormulas: any[];
    viewButtons: any = [];
    viewImpOptions: any = [];
    viewItem: any;   // this is the view item retrieved specifically for this view
    // isFormValid:boolean = false;

    mainTitle: string = "";
    modal_state: string = "modal_loading";
    conditionResults: any;
    bSavingInProcess: boolean = false;
    currentEvent: string = "";

    public processListItemsBinding: Function;     // call back for sn-field on processing list items 

    private formValueOnChangeSubject = new BehaviorSubject<any>(null);
    public formValueOnChange = this.formValueOnChangeSubject.asObservable();

    constructor(
        private ngbModal: NgbModal,
        public activeModal: NgbActiveModal,
        private uscStoreService: UscStoreService,
        private fieldService: FieldService,
        private conditionService: ConditionService,
        private dialogService: DialogService,
    ) { }

    onFormChange() {
        var newFormFields = this.formFields;
        var newFormFields = this.fieldService.formValueToFormFields(this.form.value, newFormFields);
        this.validate(newFormFields);
        this.formFields = newFormFields;
    }

    ngOnInit() {
        // must initialize form as there is a delay on retrieving the view config form server
        this.form = this.fieldService.toFormGroup(this.formFields);
        this.processListItemsBinding = this.processListItems.bind(this);
        //console.log(this.openCustomInputEvent);
        this.loadView(this.view, false);
        // console.log("usc-modal: ngOnInit");
    }

    loadView(view, bKeepFormValue: boolean) {
        // console.log("usc-modal: loadview");
        this.view = view;
        this.uscStoreService.getMetaData(view, {}).subscribe(
            result => {
                let i = 0;
                this.viewFields = result.meta_data.view_fields;
                this.viewConditions = result.meta_data.view_conditions;
                this.viewFormulas = result.meta_data.view_formulas;
                this.viewSettings = result.meta_data.view_settings;
                if (this.viewSettings.titles && this.viewSettings.titles.length > 0) {
                    this.mainTitle = this.viewSettings.titles[0].label;
                }
                if (this.viewSettings.show_options) { this.showOptions = this.viewSettings.show_options; }
                if (this.data) {
                    this.loadViewItem(bKeepFormValue);
                }
            },
            err => { console.log(err) }
        )
    }

    loadViewItem(bKeepFormValue: boolean) {
        // console.log("usc-modal: loadViewItem");
        var view_ID = this.data.dl_ID;
        if (this.view == this.uscStoreService.form_file_upload) view_ID = this.data.co_ID;
        this.uscStoreService.getViewItem(this.view, view_ID).subscribe(
            result => {
                this.viewItem = result.item;
                if (this.data && this.data.cfd_nlc && this.data.cfd_nlc == 'Referral') this.viewItem.cfd_nlc = 'Referral';
                if (bKeepFormValue) {
                    // this will discard any server return values and keep all current form values
                    var newFormFields = this.fieldService.formValueToFormFields(this.form.value, this.formFields);
                    this.uscStoreService.updateDataWithFormValues(newFormFields, this.viewItem);
                } else if (this.view == this.uscStoreService.form_interested || this.view == this.uscStoreService.form_last_interested || this.view == this.uscStoreService.form_reschedule) {
                    this.viewItem.cfd_fumd = '';
                    this.viewItem.cfd_fumts = '';
                    this.viewItem.cfd_qrfv = '';
                }
                this.formFields = this.uscStoreService.getFormFields(this.viewFields, this.viewItem);
                this.form = this.fieldService.toFormGroup(this.formFields);
                if (!bKeepFormValue && this.view == this.uscStoreService.form_lasting_impression) {
                    if (this.data.co_firstname) this.form.controls["co_firstname"].setValue(this.data.co_firstname);
                    if (this.data.co_lastname) this.form.controls["co_lastname"].setValue(this.data.co_lastname)
                    if (this.data.co_work_phone1) this.form.controls["co_work_phone1"].setValue(this.data.co_work_phone1);
                    if (this.data.dl_notes) this.form.controls["dl_notes"].setValue(this.data.dl_notes);
                    if (this.data.dl_account_type) this.form.controls["dl_account_type"].setValue(this.data.dl_account_type);
                } else if (this.view == this.uscStoreService.form_quick_sale && this.data) {
                    if (this.data.dl_ID) this.form.controls["dl_ID"].setValue(this.data.dl_ID);
                    if (this.data.view_ID) this.form.controls["view_ID"].setValue(this.data.dl_ID);
                    if (this.data.dl_type) this.form.controls["dl_type"].setValue(this.data.dl_type);
                    if (this.data.dl_sub_type) this.form.controls["dl_sub_type"].setValue(this.data.dl_sub_type);
                    if (this.data.dl_close_date) this.form.controls["dl_close_date"].setValue(this.data.dl_close_date);
                    if (this.data.cfd_oid) this.form.controls["cfd_oid"].setValue(this.data.cfd_oid);
                    if (this.data.dl_connected_device) this.form.controls["dl_connected_device"].setValue(this.data.dl_connected_device);
                    if (this.data.dl_prepaid) this.form.controls["dl_prepaid"].setValue(this.data.dl_prepaid);
                    if (this.data.dl_hsi) this.form.controls["dl_hsi"].setValue(this.data.dl_hsi);
                    if (this.data.dl_bir) this.form.controls["dl_bir"].setValue(this.data.dl_bir);
                    if (this.data.dl_estimated_value3) this.form.controls["dl_estimated_value3"].setValue(this.data.dl_estimated_value3);
                    if (this.data.dl_estimated_units3) this.form.controls["dl_estimated_units3"].setValue(this.data.dl_estimated_units3);
                    if (this.data.cfd_dti) this.form.controls["cfd_dti"].setValue(this.data.cfd_dti);
                    if (this.data.cfd_dpb) this.form.controls["cfd_dpb"].setValue(this.data.cfd_dpb);
                    if (this.data.cfd_dps) this.form.controls["cfd_dps"].setValue(this.data.cfd_dps);
                    if (this.data.cfd_dpa) this.form.controls["cfd_dpa"].setValue(this.data.cfd_dpa);
                    if (this.data.cfd_dpacs) this.form.controls["cfd_dpacs"].setValue(this.data.cfd_dpacs);
                    if (this.data.co_firstname) this.form.controls["co_firstname"].setValue(this.data.co_firstname);
                    if (this.data.co_lastname) this.form.controls["co_lastname"].setValue(this.data.co_lastname);
                    if (this.data.co_work_phone1) this.form.controls["co_work_phone1"].setValue(this.data.co_work_phone1);
                    if (this.data.cfd_an) this.form.controls["cfd_an"].setValue(this.data.cfd_an);

                    if (this.data.dl_postpaid_basic) this.form.controls["dl_postpaid_basic"].setValue(this.data.dl_postpaid_basic);
                    if (this.data.dl_postpaid_everyday) this.form.controls["dl_postpaid_everyday"].setValue(this.data.dl_postpaid_everyday);
                    if (this.data.dl_postpaid_even_better) this.form.controls["dl_postpaid_even_better"].setValue(this.data.dl_postpaid_even_better);
                    if (this.data.dl_upgrades_basic) this.form.controls["dl_upgrades_basic"].setValue(this.data.dl_upgrades_basic);
                    if (this.data.dl_upgrades_everyday) this.form.controls["dl_upgrades_everyday"].setValue(this.data.dl_upgrades_everyday);
                    if (this.data.dl_upgrades_even_better) this.form.controls["dl_upgrades_even_better"].setValue(this.data.dl_upgrades_even_better);
                    if (this.data.cfd_spiff) this.form.controls["cfd_spiff"].setValue(this.data.cfd_spiff);
                    if (this.data.cfd_spiff_desc) this.form.controls["cfd_spiff_desc"].setValue(this.data.cfd_spiff_desc);
                    // if (this.uscStoreService.isUSCellCorp() || this.uscStoreService.isUSCellAgent()) {
                    // } else {
                    //   if (this.data.dl_estimated_units) this.form.controls["dl_estimated_units"].setValue(this.data.dl_estimated_units);
                    //   if (this.data.dl_estimated_value) this.form.controls["dl_estimated_value"].setValue(this.data.dl_estimated_value);
                    //   if (this.data.dl_estimated_value4) this.form.controls["dl_estimated_value4"].setValue(this.data.dl_estimated_value4);
                    //   if (this.data.dl_estimated_units5) this.form.controls["dl_estimated_units5"].setValue(this.data.dl_estimated_units5);
                    // }
                }

                // must validate all form fields due to other control dependencies
                this.validate(this.formFields);
                // // event listner: subscribe to form value change event
                this.form.valueChanges.subscribe(data => {
                    for (var i = 0; i < this.formFields.length; i++) {
                        var field = this.formFields[i];
                        switch (field.display_type) {
                            // HACK: when valueChanges got trigger (ie. list item change in dropdown) multiselect field values get cleared for no reason, lets set the value back manually
                            case MultiSelectField.control_type:
                                if (field && field.value && field.value.split) this.form.value[field.key] = field.value.split(';');
                                break;
                            case MultiSelectListField.control_type:
                                if (field && field.value && field.value.split) this.form.value[field.key] = field.value.split('; ');
                               break;
                        }
                    }
                    this.onFormChange();
                });
                this.modal_state = "modal_loaded";
            },
            err => { console.log(err) }
        );
    }

    validate(updateFormFields: Array<Field<any>>) {
        if (this.viewConditions && updateFormFields) {
            this.conditionResults = this.conditionService.evaluateFormValues(this.viewConditions, this.formFields, updateFormFields);
            updateFormFields.forEach(f => {
                this.validateField(f);
            })
        }
    }

    validateField(field) {
        if (field.condition) {
            let ctrl = this.form.get(field.key);
            ctrl.setErrors(null);
            let condResult = this.conditionService.getCondition(this.conditionResults, field.condition);
            if (condResult && !condResult.result) {
                ctrl.setErrors(condResult.error);
                return condResult;
            }
        }
    }

    isConditionValid(condition) {
        let condResult = this.conditionService.getCondition(this.conditionResults, condition);
        return condResult;
    }

    onSubmit(event, btn_event) {
        this.onFormChange();
        if (this.form.valid) {
            console.log(btn_event);
            var newFormFields = this.fieldService.formValueToFormFields(this.form.value, this.formFields);
            var services = { uscStoreService: this.uscStoreService, dialogService: this.dialogService, ngbModal: this.ngbModal, activeModal: this.activeModal, view: this.view, view_ID: this.viewItem.view_ID }
            if (this.onCustomValidateEvent) {
                var validation = this.onCustomValidateEvent(services, event, btn_event, newFormFields);
                if (validation) {
                    if (validation.status) {
                        this.processSubmission(services, event, btn_event, newFormFields);
                        // if (this.onSubmitOverrideEvent) {
                        //     var services = { uscStoreService: this.uscStoreService, ngbModal: this.ngbModal }
                        //     this.onSubmitOverrideEvent(services, event, btn_event, newFormFields);
                        //     this.activeModal.close({ event: btn_event, data: null });
                        // } else {
                        //     if (this.form.value["cfd_dnc"] == "Yes") {
                        //         this.showDoNotCallDlg(event, btn_event, newFormFields);
                        //     } else {
                        //         this.continueOnSubmit(event, btn_event, newFormFields);
                        //     }
                        // }
                    } else if (!validation.status) {
                        this.openOkDialog(validation.error_msg);
                    }
                }
            } else {
                this.processSubmission(services, event, btn_event, newFormFields);
                // if (this.onSubmitOverrideEvent) {
                //     var services = { uscStoreService: this.uscStoreService, ngbModal: this.ngbModal }
                //     this.onSubmitOverrideEvent(services, event, btn_event, newFormFields);
                //     this.activeModal.close({ event: btn_event, data: null });
                // } else {
                //     if (this.form.value["cfd_dnc"] == "Yes") {
                //         this.showDoNotCallDlg(event, btn_event, newFormFields);
                //     } else {
                //         this.continueOnSubmit(event, btn_event, newFormFields);
                //     }
                // }
            }
        }
    }

    processSubmission(services, event, btn_event, newFormFields) {
        if (this.onSubmitOverrideEvent) {
            this.onSubmitOverrideEvent(services, event, btn_event, newFormFields);
            //this.activeModal.close({ event: btn_event, data: null });
        } else {
            if (this.form.value["cfd_dnc"] == "Yes") {
                this.showDoNotCallDlg(event, btn_event, newFormFields);
            } else {
                this.continueOnSubmit(event, btn_event, newFormFields);
            }
        }        
    }

    continueOnSubmit(event, btn_event, newFormFields) {
        this.bSavingInProcess = true;
        var prev_event = this.currentEvent;
        this.currentEvent = btn_event;
        if (btn_event == "  ") {
            this.activeModal.close({ event: btn_event, data: null });
        } else {
            var item_ID = this.viewItem.dl_ID;
            var params = { event: btn_event };
            if (this.view == this.uscStoreService.form_file_upload) item_ID = this.data.co_ID;
            this.uscStoreService.saveOutcome(this.view, item_ID, newFormFields, params).subscribe(
                result => {
                    if (result.status == "Failure") {
                        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
                        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_ok_prompt;
                        var message = `Unable to reserve the selected time slot. (${result.message})`;
                        modalRef.componentInstance.msg_config = { msg: message };
                        modalRef.result.then((result) => {
                            this.bSavingInProcess = false;
                            this.currentEvent = prev_event;
                        }, (reason) => {
                            this.bSavingInProcess = false;
                            this.currentEvent = prev_event;
                        });
                    } else {
                        this.uscStoreService.setViewItemUpdated(this.viewItem, true);
                        if (btn_event == "archive") {
                            for (var l = 0; l < result.length; l++) {
                                if (result[l].key == "dl_ID") {
                                    this.uscStoreService.processActionOnViewItem(this.view, result[l].value, this.uscStoreService.action_mass_archive, "").subscribe(
                                        result2 => {
                                            this.activeModal.close({ event: btn_event, data: result, archived: true });
                                            this.bSavingInProcess = false;
                                            this.currentEvent = "";
                                        }
                                    );
                                    break;
                                }
                            }
                        } else {
                            this.activeModal.close({ event: btn_event, data: result });
                            this.bSavingInProcess = false;
                            this.currentEvent = "";
                        }
                    }
                }
            );
        }
    }

    showDoNotCallDlg(event, btn_event, newFormFields) {
        this.modal_state = "modal_loading"
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.parentView = this.view;
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_do_not_call;

        var curForm = this;
        modalRef.result.then((result) => {
            curForm.modal_state = "modal_loaded";
            //console.log(result);
            this.continueOnSubmit(event, btn_event, newFormFields);
        }, (reason) => {
            curForm.modal_state = "modal_loaded";
            console.log("Do Not Call Cancelled");
        });
    }

    onOptionsChange(e, o) {
        if (o.reload_view && o.value != this.view) {
            this.loadView(o.value, true);
        }
    }

    isButtonVisible(btn) {
        var condResult = this.isConditionValid(btn.sn_visible);
        //console.log(condResult);
        return condResult ? condResult.result : true;
    }

    isFieldVisible(field) {
        var condResult = this.isConditionValid(field.sn_visible);
        //if (field.sn_visible == 'sa_url') console.log(condResult);
        //console.log(condResult);
        return condResult ? condResult.result : true;
    }

    processListItems(view, item, field, fm) {
        return this.uscStoreService.processListItems(view, item, field, fm.list_items, this.formFields);
    }

    // triggered on emitted event (valueChange)
    // TODO: update form values based on the field type, not the view
    valueChange(content) {
        console.log(content);
        switch (content.field.display_type) {
            case FileField.control_type:
                // switch (this.view) {
                //   case this.uscStoreService.form_file_upload:
                if (content.file && content.file.ID) {
                    // set value to the control to retain this value
                    this.form.controls["fl_ID"].setValue(content.file.ID);
                }
                break;
            case MultiSelectField.control_type:
                if (content.field.value) {
                    // HACK: the form value didn't auto update when the field value was changed by the (change) event
                    // have to manually update the form.value
                    this.form.value[content.field.key] = content.field.value;
                }
                break;
        }

        // handle control dependancies on value change (ie parent change should update child controls)
        if (content && content.field && content.field.child_controls) {
            console.log(content.field, content.field.child_controls);
            this.formValueOnChangeSubject.next(content.field);
        }
        this.onFormChange();
    }

    dismiss() {
        if (!this.bSavingInProcess) this.activeModal.dismiss();
    }

    openUserLookup(): NgbModalRef {
        return this.ngbModal.open(UscUserLookupComponent, { size: "lg", backdrop: 'static', keyboard: false });
    }

    findNonEmptyErrorMsg(invalid_conditions) {
        var error_msg = "";
        invalid_conditions.forEach(
            c => {
                if (error_msg.length == 0 && c.error_msg && c.error_msg.length > 0) {
                    error_msg = c.error_msg;
                }
            }
        )
        return error_msg;
    }

    getErrorMsg(field) {
        var condResult = this.validateField(field);
        var error_msg = "";
        if (condResult && this.isFieldVisible(field)) {
            if (condResult.error_msg) {
                error_msg = condResult.error_msg;
            } else if (condResult.invalid_conditions && condResult.invalid_conditions.length > 0) {
                error_msg = this.findNonEmptyErrorMsg(condResult.invalid_conditions);
            } else if (condResult.unchanged_conditions && condResult.unchanged_conditions.length > 0) {
                error_msg = this.findNonEmptyErrorMsg(condResult.unchanged_conditions);
            }
        }
        return error_msg;
    }

    getCurrentFormValues(): any { return this.form.value; }

    // helper methods - begin
    public openOkDialog(message) {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_ok_prompt;
        modalRef.componentInstance.msg_config = { msg: message };
        modalRef.result.then((result) => { }, (reason) => { });
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-modal/usc-modal.component.ts